"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddSquareIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AddSquareIcon = exports.AddSquareIcon = function AddSquareIcon(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#2F2F2F" : _ref$color;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      clipPath: "url(#clip0_1772_18284)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M19 0.990112H5C2.243 0.990112 0 3.23311 0 5.99011V19.9901C0 22.7471 2.243 24.9901 5 24.9901H19C21.757 24.9901 24 22.7471 24 19.9901V5.99011C24 3.23311 21.757 0.990112 19 0.990112ZM16 13.9901H13V16.9901C13 17.5431 12.552 17.9901 12 17.9901C11.448 17.9901 11 17.5431 11 16.9901V13.9901H8C7.448 13.9901 7 13.5431 7 12.9901C7 12.4371 7.448 11.9901 8 11.9901H11V8.99011C11 8.43711 11.448 7.99011 12 7.99011C12.552 7.99011 13 8.43711 13 8.99011V11.9901H16C16.552 11.9901 17 12.4371 17 12.9901C17 13.5431 16.552 13.9901 16 13.9901Z",
        fill: color
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_1772_18284",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0 0.990112)"
        })
      })
    })]
  });
};